// 테이블에서 숨길 컬럼 목록
export const HIDDEN_COLUMNS = [
  'apartment_number',
  'total_parking_spaces',
  'total_building_count',
  'floor_area_ratio',
  'building_coverage_ratio',
  'address',
  'supply_area',
  'exclusive_ratio',
  'recent_actual_transaction_floor',
  'recent_actual_transaction_formattedtradeyearmonth',
  'recent_actual_transaction_formattedprice',
  'recent_actual_transaction_representativearea',
  'recent_actual_transaction_exclusivearea',
  'schoolname',
  'studentcountperclassroom',
  'walktime',
  'organizationtype',
  'sale_count',
  'jeonse_count',
  'current_vs_peak_price',
  'previous_lowest_price_date',
  'previous_peak_price_date',
  'actual_jeonse_transaction_date',
  'actual_sale_transaction_date',
  'last_modified',
  'subdistrict_number',
];

// 원하는 컬럼 순서 (앞쪽에 배치)
export const DESIRED_COLUMN_ORDER = [
  'apartment_name',
  'subdistrict_name',
  'move_in_date',
  'exclusive_area',
  'size_type',
  'rooms_bathrooms',
  'total_households',
  'household_count',
  'type',
];

// 기본 컬럼 이름 매핑 (한글)
export const BASE_COLUMN_NAME_MAPPING = {
  'total_households': '총세대수',
  'move_in_date': '입주일',
  'apartment_name': '아파트명',
  'size_type': '평형',
  'subdistrict_name': '동',
  'exclusive_area': '전용면적',
  'type': '타입',
  'household_count': '세대수',
  'rooms_bathrooms': '방/욕실',
  'sale_price': '매매가',
  'jeonse_price': '전세가',
  'trading_gap': '전매갭',
  'jeonse_ratio': '전세가율',
  'actual_sale_transaction_price': '실거래매매',
  'actual_jeonse_transaction_price': '실거래전세',
  'previous_lowest_price_price': '전저점매매',
  'previous_peak_price_price': '전고점매매',
  'peak_comparison': '전고점대비',
  '매물_리스트_확인': '매물 리스트 확인',
};

// AptMetrix 전용 추가 매핑
export const APTMETRIX_COLUMN_NAME_MAPPING = {
  ...BASE_COLUMN_NAME_MAPPING,
  'bookmark': '찜',
  'subway_total_time': '강남역소요시간',
  'subway_total_distance': '강남역거리',
  'subway_station_count': '강남역정류장수',
};

// 기본 정렬 가능 컬럼
export const BASE_SORTABLE_COLUMNS = [
  'exclusive_area',
  'total_households',
  'sale_price',
  'jeonse_price',
  'trading_gap',
  'peak_comparison',
];

// AptMetrix 전용 정렬 가능 컬럼
export const APTMETRIX_SORTABLE_COLUMNS = [
  ...BASE_SORTABLE_COLUMNS,
  'subway_total_time',
  'subway_total_distance',
  'subway_station_count',
];

/**
 * columnOrder에서 hidden 컬럼을 제거하고 desiredOrder 순서로 정렬한 최종 컬럼 목록을 반환한다.
 */
export function buildFinalColumnOrder(columnOrder, { includeBookmark = false } = {}) {
  const filtered = columnOrder.filter(col => !HIDDEN_COLUMNS.includes(col));
  const ordered = DESIRED_COLUMN_ORDER.filter(col => filtered.includes(col));
  const remaining = filtered.filter(col => !DESIRED_COLUMN_ORDER.includes(col));
  const columns = [...ordered, ...remaining];
  return includeBookmark ? ['bookmark', ...columns] : columns;
}
